import { RequiredNotification } from '@Components/index';
import { useAppSelector } from '@Hooks/index';
import { getModalRecordKey } from '@Store/selectors/modalSelector';
import { useUpdateTenderModeMutation } from '../../TenderRequest/store/api/TenderRequestApiSlice';

interface UpdateTenderModeModalProps {
  isOpen: boolean;
  onCancel: () => void;
}

const UpdateTenderModeModal: React.FC<UpdateTenderModeModalProps> = ({
  isOpen,
  onCancel,
}) => {
  const modalRecordKey = useAppSelector(getModalRecordKey);
  const [updateTenderMode] = useUpdateTenderModeMutation();

  return (
    <RequiredNotification
      title="Update Tender Mode"
      message="Are you sure you want to update the tender mode?"
      isModalOpen={isOpen}
      textSuccessBtn="Update"
      isSuccessIcon
      handleCancel={onCancel}
      handleSuccess={() => {
        updateTenderMode(modalRecordKey).finally(() => {
          onCancel();
        });
      }}
    />
  );
};

export default UpdateTenderModeModal;
